// extracted by mini-css-extract-plugin
export var chip = "_5e-0";
export var filterDropdown = "_5e-5";
export var filterItem = "_5e-6";
export var icon = "_5e-1";
export var removeButton = "_5e-3";
export var removeIcon = "_5e-4";
export var separator = "_5e-2";